module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_9016.7dc07aa3.png";